import store from '@/store'
import {
  duplicatePost,
  getPostById,
  getPostByRef,
  mergePost,
  patchPost,
  deletePost, deleteAllPosts
} from '@/services/posts'
import { Message } from 'element-ui'
import { $t } from '@/i18n'
import { handlePostAction } from '@/stores/helpers/postActions'

const POST_STATUS = {
  DRAFT: 'B'
}

const REFERENCE_REGEX = /^[a-zA-Z0-9\_\-\ \.]+$/

export default {
  namespaced: true,
  state: {
    bienVenduModaleArchiveNOk: false,
    bienVenduModaleArchiveOk: false,
    currentLandId: null,
    currentModelId: null,
    currentProgramId: null,
    deleteId: null,
    listeModeles: [],
    listeProgramModeles: [],
    listeTerrains: [],
    loadingCMIcreatePost: false,
    modalCmisteModelDisabled: false,
    modalConfirmedDeleteList: false,
    modalDelete: false,
    modalDuplicate: false,
    modalShowProgramsPromoter: false,
    modalUseModel: false,
    postToDelete: null,
    referenceDuplication: null,
    selectTypeObjetModele: null,
    tailleSelectPopup: 12,
    modalShowModelsCmiste: false,
    loadingStatus: false
  },
  getters: {
    bienVenduModaleArchiveNOk: state => state.bienVenduModaleArchiveNOk,
    bienVenduModaleArchiveOk: state => state.bienVenduModaleArchiveOk,
    currentLandId: state => state.currentLandId,
    currentModelId: state => state.currentModelId,
    currentProgramId: state => state.currentProgramId,
    listeModeles: state => state.listeModeles,
    listeProgramModeles: state => state.listeProgramModeles,
    listeTerrains: state => state.listeTerrains,
    loadingCMIcreatePost: state => state.loadingCMIcreatePost,
    modalCmisteModelDisabled: state => state.modalCmisteModelDisabled,
    modalConfirmedDeleteList: state => state.modalConfirmedDeleteList,
    modalDelete: state => state.modalDelete,
    modalDuplicate: state => state.modalDuplicate,
    modalShowProgramsPromoter: state => state.modalShowProgramsPromoter,
    modalUseModel: state => state.modalUseModel,
    postToDelete: state => state.postToDelete,
    selectTypeObjetModele: state => state.selectTypeObjetModele,
    tailleSelectPopup: state => state.tailleSelectPopup,
    referenceDuplication: state => state.referenceDuplication,
    modalShowModelsCmiste: state => state.modalShowModelsCmiste,
    loadingStatus: state => state.loadingStatus
  },
  mutations: {
    SET_BIEN_VENDU_MODALE_ARCHIVE_NOK (state, bienVenduModaleArchiveNOk) {
      state.bienVenduModaleArchiveNOk = bienVenduModaleArchiveNOk
    },
    SET_BIEN_VENDU_MODALE_ARCHIVE_OK (state, bienVenduModaleArchiveOk) {
      state.bienVenduModaleArchiveOk = bienVenduModaleArchiveOk
    },
    SET_CURRENT_LAND_ID (state, currentLandId) {
      state.currentLandId = currentLandId
    },
    SET_REFERENCE_DUPLICATION (state, referenceDuplication) {
      state.referenceDuplication = referenceDuplication
    },
    SET_CURRENT_MODEL_ID (state, currentModelId) {
      state.currentModelId = currentModelId
    },
    SET_CURRENT_PROGRAM_ID (state, currentProgramId) {
      state.currentProgramId = currentProgramId
    },
    SET_LISTE_MODELES (state, listeModeles) {
      state.listeModeles = listeModeles
    },
    SET_LISTE_PROGRAM_MODELES (state, listeProgramModeles) {
      state.listeProgramModeles = listeProgramModeles
    },
    SET_MODAL_SHOW_MODELS_CMISTE (state, modalShowModelsCmiste) {
      state.modalShowModelsCmiste = modalShowModelsCmiste
    },
    SET_LISTE_TERRAINS (state, listeTerrains) {
      state.listeTerrains = listeTerrains
    },
    SET_LOADING_CMI_CREATE_POST (state, loading) {
      state.loadingCMIcreatePost = loading
    },
    SET_MODAL_CMISTE_MODEL_DISABLED (state, modalCmisteModelDisabled) {
      state.modalCmisteModelDisabled = modalCmisteModelDisabled
    },
    SET_MODAL_CONFIRMED_DELETE_LIST (state, modalConfirmedDeleteList) {
      state.modalConfirmedDeleteList = modalConfirmedDeleteList
    },
    SET_MODAL_DELETE (state, modalDelete) {
      state.modalDelete = modalDelete
    },
    SET_MODAL_DUPLICATE (state, modalDuplicate) {
      state.modalDuplicate = modalDuplicate
    },
    SET_MODAL_SHOW_PROGRAMS_PROMOTER (state, modalShowProgramsPromoter) {
      state.modalShowProgramsPromoter = modalShowProgramsPromoter
    },
    SET_MODAL_USE_MODEL (state, modalUseModel) {
      state.modalUseModel = modalUseModel
    },
    SET_POST_TO_DELETE (state, postToDelete) {
      state.postToDelete = postToDelete
    },
    SET_SELECT_TYPE_OBJET_MODELE (state, selectTypeObjetModele) {
      state.selectTypeObjetModele = selectTypeObjetModele
    },
    SET_TAILLE_SELECT_POPUP (state, tailleSelectPopup) {
      state.tailleSelectPopup = tailleSelectPopup
    },
    SET_LOADING_STATUS (state, value) {
      state.loadingStatus = value
    }
  },
  actions: {
    async duplicatePost ({ dispatch, commit }, { id, reference }) {
      commit('SET_LOADING_STATUS', true)
      try {
        const checkExistingPost = await getPostByRef(reference)
        if(checkExistingPost.total === 0) {
          const responseDuplicate = await handlePostAction({
            commit,
            action: () => duplicatePost(id, reference),
            params: { reference },
            successMessage: $t('validator.addDuplicate')
          })
          return responseDuplicate
        } else {
          Message($t('validator.referenceAlreadyExists'))
        }
      } catch (error) {
        console.log(error)
      } finally {
        commit('SET_LOADING_STATUS', false)
        commit('SET_MODAL_SHOW_MODELS_CMISTE', false)
        commit('SET_REFERENCE_DUPLICATION', null)
        commit('SET_SELECT_TYPE_OBJET_MODELE', null)
        commit('SET_CURRENT_LAND_ID', null)
        commit('SET_CURRENT_MODEL_ID', null)
        commit('SET_CURRENT_PROGRAM_ID', null)
        commit('SET_MODAL_DUPLICATE', false)
        commit('SET_MODAL_USE_MODEL', false)
        commit('SET_MODAL_CONFIRMED_DELETE_LIST', false)
      }
    },
    async patchPost ({ commit }, post) {
      try {
        const response = await patchPost(post, store.state.app.sitimmoUser.login, 'SAISIE_IMMO')
        return response
      } catch (error) {
        console.log(error)
        Message({
          type: 'error',
          message: $t('error.found')
        })
        return { type: 'error' }
      }
    },
    async deleteAllPosts ({ commit, dispatch }, annonces) {
      try {
        commit('SET_LOADING_STATUS', true)
        const response = await deleteAllPosts(annonces)
        if (response.type === 'success') {
          Message({
            message: $t('validator.addDelete'),
            type: 'success'
          })

          await dispatch('loadPosts')
          store.commit('postsListImmo/SET_SELECTION', [])

          return { type: 'success' }
        }

        return {
          type: 'error',
          message: $t('error.found')
        }
      } catch (error) {
        console.error('Error deleting all posts:', error)
        Message({
          type: 'error',
          message: $t('error.found')
        })
        return { type: 'error' }
      } finally {
        commit('SET_LOADING_STATUS', false)
        commit('SET_MODAL_SHOW_MODELS_CMISTE', false)
        commit('SET_REFERENCE_DUPLICATION', null)
        commit('SET_SELECT_TYPE_OBJET_MODELE', null)
        commit('SET_CURRENT_LAND_ID', null)
        commit('SET_CURRENT_MODEL_ID', null)
        commit('SET_CURRENT_PROGRAM_ID', null)
        commit('SET_MODAL_CONFIRMED_DELETE_LIST', false)
      }
    },
    async deletePost ({ commit, dispatch }, id) {
      try {
        console.log(id)
        const response = await deletePost(id)

        if (response.type === 'error') {
          Message({
            message: $t('error.found'),
            type: 'error'
          })
          return { type: 'error' }
        }

        // Reset des états
        commit('SET_MODAL_CONFIRMED_DELETE_LIST', false)
        commit('SET_MODAL_DELETE', false)
        commit('SET_BIEN_VENDU_MODALE_ARCHIVE_OK', false)

        Message({
          message: $t('posts.dialog.deleteNotification'),
          type: 'success'
        })

        return { type: 'success' }
      } catch (error) {
        commit('SET_MODAL_CONFIRMED_DELETE_LIST', false)
        commit('SET_MODAL_DELETE', false)
        commit('SET_BIEN_VENDU_MODALE_ARCHIVE_OK', false)
        console.error('Error deleting post:', error)
        Message({
          message: $t('error.found'),
          type: 'error'
        })
        return { type: 'error' }
      }
    },
    trackProgramCreation ({ rootState }) {
      this._vm.$ga.event(
        'annonce',
        'clic',
        'confirmer_programme',
        rootState.app.sitimmoUser.id
      )
    },

    async handleInitialPostCreation ({ commit }, state) {
      if (state.landId && state.modelId) {
        return handlePostAction({
          commit,
          action: () => mergePost(state.landId, state.modelId, state.reference),
          successMessage: 'validator.addMerge'
        })
      }

      const idCurrent = state.programId || state.modelId
      return handlePostAction({
        commit,
        action: () => duplicatePost(idCurrent, state.reference),
        successMessage: 'validator.addDuplicate'
      })
    },

    async handlePostUpdate ({ commit }, { postData, userLogin }) {
      return handlePostAction({
        commit,
        action: () => patchPost(postData, userLogin, 'SAISIE_IMMO'),
        successMessage: 'validator.addUpdate'
      })
    },

    async fusionnerPost ({ commit, dispatch, rootState }, state) {
      console.log('Merge')
      console.log(state)
      try {
        commit('SET_LOADING_CMI_CREATE_POST', true)

        await dispatch('trackProgramCreation')

        const postCreated = await dispatch('handleInitialPostCreation', state)
        if (!postCreated.type === 'success') {
          return { type: 'error' }
        }
        console.log(postCreated)
        const postDataToPatch = await dispatch('preparePostData', {
          postId: postCreated.id,
          state,
          sitimmoUser: rootState.app.sitimmoUser,
          selectTypeObjetModele: state.selectTypeObjetModele
        })

        const response = await dispatch('handlePostUpdate', {
          postData: postDataToPatch,
          userLogin: rootState.app.sitimmoUser.login
        })

        return {
          type: response.type,
          data: postCreated
        }
      } catch (error) {
        console.error('Error in fusionnerPost:', error)
        return { type: 'error' }
      } finally {
        commit('SET_LOADING_CMI_CREATE_POST', false)
        commit('SET_MODAL_SHOW_MODELS_CMISTE', false)
        commit('SET_LOADING_STATUS', false)
        commit('SET_MODAL_SHOW_MODELS_CMISTE', false)
        commit('SET_REFERENCE_DUPLICATION', null)
        commit('SET_SELECT_TYPE_OBJET_MODELE', null)
        commit('SET_CURRENT_LAND_ID', null)
        commit('SET_CURRENT_MODEL_ID', null)
        commit('SET_CURRENT_PROGRAM_ID', null)
      }
    },

    async preparePostData ({ commit }, { postId, state, sitimmoUser, selectTypeObjetModele }) {
      const postDataToPatch = await getPostById(postId)

      if (state.landId && state.modelId) {
        const [previousLand, previousModel] = await Promise.all([
          getPostById(state.landId),
          getPostById(state.modelId)
        ])

        return {
          ...postDataToPatch,
          code_type_objet: selectTypeObjetModele,
          texte: `${previousModel.texte}\r\n\r\n${previousLand.texte}`,
          prix: previousLand.prix + previousModel.prix,
          prix_terrain: previousLand.prix,
          STATUS: 'B'
        }
      }

      if (!state.landId && state.modelId) {
        const previousModel = await getPostById(state.modelId)
        return {
          ...postDataToPatch,
          texte: previousModel.texte,
          prix: previousModel.prix,
          ville_reelle: sitimmoUser.ville,
          code_postal_reel: sitimmoUser.codePostal,
          ville: sitimmoUser.ville,
          code_postal: sitimmoUser.codePostal,
          communiquer_adresse_exacte: true,
          code_type_objet: '5200',
          STATUS: 'B'
        }
      }

      return {
        code_type_objet: selectTypeObjetModele,
        STATUS: 'B',
        id: postId
      }
    }
  }
}
